import { Icon } from '@iconify/react'
import { Button } from 'antd'
import React, { FunctionComponent, memo } from 'react'

const iconStyle =
  'transition-colors w-auto h-5 text-primary hover:text-primaryHover cursor-pointer'

export interface ToggleControl {
  active: boolean
  onToggle: () => void
}

export interface BuybackFormHeaderActionsProps {
  onClose: () => void
  help?: ToggleControl
  chart?: ToggleControl
  table?: ToggleControl
  settings?: ToggleControl
}

export const BuybackFormHeaderActions: FunctionComponent<BuybackFormHeaderActionsProps> =
  memo(({ onClose, help, chart, table, settings }) => {
    return (
      <div className="flex space-x-2 items-center">
        {help && (
          <Icon
            icon={help.active ? 'tabler:help-off' : 'tabler:help'}
            onClick={help.onToggle}
            className={iconStyle}
          />
        )}

        {chart && (
          <Icon
            icon={
              chart.active
                ? 'material-symbols:bar-chart-off-rounded'
                : 'material-symbols:bar-chart-rounded'
            }
            onClick={chart.onToggle}
            className={iconStyle}
          />
        )}

        {table && (
          <Icon
            icon={table.active ? 'mdi:table-off' : 'mdi:table'}
            onClick={table.onToggle}
            className={iconStyle}
          />
        )}

        {settings && (
          <Icon
            icon={settings.active ? 'tabler:settings-off' : 'tabler:settings'}
            onClick={settings.onToggle}
            className={iconStyle}
          />
        )}

        <div className="h-6 !ml-4 border-l border-gray-300" />

        <Button type="link" size="small" onClick={onClose} className="!pr-0">
          Zavřít
        </Button>
      </div>
    )
  })
